(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('UnitFranchiseeHistoryFormFranchiserController', UnitFranchiseeHistoryFormFranchiserController)

    /** @ngInject */
    function UnitFranchiseeHistoryFormFranchiserController($q, $state, $stateParams, $location, UnitService, StateService, CityService, FranchiseeHistoryService, HelperService) {
        const vm = this;
        const queryStrings = $location.search();

        let allCities = [];
        let allUnits = [];

        vm.saveFranchisee = () => {
            if (!vm.selectedState) {
                HelperService.setErrorMessageForm('.state');
                return;
            }

            if (!vm.selectedCity) {
                HelperService.setErrorMessageForm('.city');
                return;
            }

            if (!vm.selectedUnit) {
                HelperService.setErrorMessageForm('.unit');
                return;
            }

            HelperService.startLoading('.loading-holder');

            let franchiseeData = angular.copy(vm.franchiseeData);

            franchiseeData.Birthdate = HelperService.getMomentDate(franchiseeData.BirthdateFormatted).format('YYYY-MM-DD');

            franchiseeData.FranchiseeHistory_Phone.Phone.Code = String(franchiseeData.FranchiseeHistory_Phone.Phone.NumberComplete.substr(0, 2));
            franchiseeData.FranchiseeHistory_Phone.Phone.Number = String(franchiseeData.FranchiseeHistory_Phone.Phone.NumberComplete.substr(2, 10));
            franchiseeData.FranchiseeHistory_Phone = [franchiseeData.FranchiseeHistory_Phone];
            franchiseeData.FranchiseeHistory_Email = [franchiseeData.FranchiseeHistory_Email];
            franchiseeData.FranchiseeHistory_Document = [franchiseeData.FranchiseeHistory_Document];

            franchiseeData.FranchiseeHistory_Address.Address.CityId = vm.selectedCity.Id;
            franchiseeData.FranchiseeHistory_Address = [franchiseeData.FranchiseeHistory_Address];

            franchiseeData.UnitId = vm.selectedUnit.Id;

            if (!franchiseeData.Id) {
                FranchiseeHistoryService
                    .post(franchiseeData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                FranchiseeHistoryService
                    .put(franchiseeData)
                    .then(successCallback, errorCallback);
            }
        }

        vm.getUnits = search => {
            if (!search) {
                vm.units = [];
                return;
            }

            vm.units = allUnits.filter(unit => filterUnit(unit, search))
        }

        vm.getCities = preSelectedCityId => {
            delete vm.selectedCity;

            vm.cities = [];
            vm.cityPlaceholder = 'AGUARDE...';

            return CityService
                .getByState(vm.selectedState.Id)
                .then(success => {
                    if (!success.length)
                        vm.cityPlaceholder = 'NENHUM RESULTADO';
                    else
                        vm.cityPlaceholder = 'ESCOLHA A CIDADE';

                    allCities = success;

                    if (preSelectedCityId)
                        vm.selectedCity = allCities.find(city => (city.Id == preSelectedCityId));
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        vm.searchCities = search => {
            if (!search) {
                vm.units = [];
                return;
            }

            vm.cities = allCities.filter(unit => filterCity(unit, search));
        }

        vm.changeFranchiseeStatus = status => {
            vm.franchiseeData.Active = status;
        }

        init();

        function getFranchisee() {
            const franchiseeId = $stateParams.franchiseeId;

            if (!franchiseeId) {
                HelperService.stopLoading('.loading-holder');
                return;
            }

            FranchiseeHistoryService
                .get(franchiseeId)
                .then(success => {
                    vm.franchiseeData = success;

                    if (vm.franchiseeData.FranchiseeHistory_Phone && vm.franchiseeData.FranchiseeHistory_Phone.length) {
                        vm.franchiseeData.FranchiseeHistory_Phone = vm.franchiseeData.FranchiseeHistory_Phone.reduce((acc, cur) => {
                            cur.Phone.NumberComplete = String(cur.Phone.Code.concat(cur.Phone.Number)).replace(/-/g, '');
                            acc = cur;

                            return acc;
                        }, {});
                    }

                    if (vm.franchiseeData.FranchiseeHistory_Email && vm.franchiseeData.FranchiseeHistory_Email.length) {
                        vm.franchiseeData.FranchiseeHistory_Email = vm.franchiseeData.FranchiseeHistory_Email.reduce((acc, cur) => {
                            acc = cur;

                            return acc;
                        }, {});
                    }

                    if (vm.franchiseeData.FranchiseeHistory_Document && vm.franchiseeData.FranchiseeHistory_Document.length) {
                        vm.franchiseeData.FranchiseeHistory_Document = vm.franchiseeData.FranchiseeHistory_Document.reduce((acc, cur) => {
                            if (cur.DocumentTypeId == 1)
                                acc = cur;

                            return acc;
                        }, {});
                    }

                    if (vm.franchiseeData.FranchiseeHistory_Address && vm.franchiseeData.FranchiseeHistory_Address.length) {
                        vm.franchiseeData.FranchiseeHistory_Address = vm.franchiseeData.FranchiseeHistory_Address.reduce((acc, cur) => {
                            acc = cur;

                            return acc;
                        }, {});
                    }

                    if (vm.franchiseeData.Birthdate)
                        vm.franchiseeData.BirthdateFormatted = moment(vm.franchiseeData.Birthdate).format('DD/MM/YYYY HH:mm:ss');

                    if (vm.franchiseeData.RegistrationDate)
                        vm.franchiseeData.RegistrationDateFormatted = moment(vm.franchiseeData.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');

                    vm.selectedState = vm.states.find(state => state.Id = vm.franchiseeData.FranchiseeHistory_Address.Address.City.StateId);
                    vm.getCities(vm.franchiseeData.FranchiseeHistory_Address.Address.CityId);

                    vm.selectedUnit = allUnits.find(unit => unit.Id == vm.franchiseeData.UnitId);

                    HelperService.stopLoading('.loading-holder');
                }, error => errorCallback(error));
        }

        function getAllUnitsResumed() {
            return UnitService
                .getAllResumed()
                .then(success => {
                    allUnits = success;

                    if (queryStrings && queryStrings.unitId)
                        vm.selectedUnit = allUnits.find(unit => unit.Id = queryStrings.unitId);
                }, error => errorCallback(error));
        }

        function getStates() {
            return StateService
                .getAll()
                .then(success => vm.states = success.filter(state => (state.Id != 0)),
                    error => errorCallback(error));
        }

        function filterCity(city, search) {
            if (city.Name == null)
                city.Name = '';

            if (city.Name.toLowerCase().includes(search.toLowerCase()))
                return city;
        }

        function filterUnit(unit, search) {
            if (unit.FantasyName == null)
                unit.FantasyName = '';

            if (unit.CorporateName == null)
                unit.CorporateName = '';

            if (unit.UniqueCode == null)
                unit.UniqueCode = '';

            if (unit.ExternalCode == null)
                unit.ExternalCode = '';

            if (unit.FantasyName.toLowerCase().includes(search.toLowerCase()) || unit.CorporateName.toLowerCase().includes(search.toLowerCase()) ||
                unit.UniqueCode.toString().includes(search) || unit.ExternalCode.toString().includes(search))
                return unit;
        }

        function successCallback(success, isPost) {
            if (isPost) {
                HelperService.successCallback();

                vm.franchiseeData = success;

                $state.go('app.franchiser-units-franchisee-edit', {
                    franchiseeId: vm.franchiseeData.Id
                }, {
                    notify: false
                });
            } else
                HelperService.successCallback('update');

            HelperService.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            HelperService.stopLoading('.loading-holder');
            HelperService.errorCallback(error);
        }

        function init() {
            vm.franchiseeData = {
                Active: true
            };
            vm.selectedUnit;
            vm.selectedState = null;
            vm.selectedCity = null;
            vm.cityPlaceholder = 'ESCOLHA UM ESTADO';

            HelperService.startLoading('.loading-holder');

            $q.all([getStates(), getAllUnitsResumed()])
                .then(() => {
                    getFranchisee();
                })
        }
    }
}());